import { fbAnalytics } from 'src/boot/firebase'

export function sendAnalytics(event, _parameters) {
  if (!import.meta.env.DEV) {
    // not initialised in the Android app (web-only SDK)
    if (!fbAnalytics) return

    if (_parameters) fbAnalytics.logEvent(event, _parameters)
    else fbAnalytics.logEvent(event)

  } else {
    console.log('sendAnalytics - ' + event, _parameters)
  }
}
